<button [type]="type" class="btn btn-{{ color }}" [ngClass]="{ 'btn-block': block }" [disabled]="disabled"
	(click)="click()">
	{{ text }}
	<span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</button>